import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("text-image-aside-reverse", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-text-aside-reverse"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
        traits: [
          {
            type: "checkbox",
            label: "Invert layout",
            name: "data-reverse",
            valueTrue: "1",
            valueFalse: "0",
          },
        ],
      },
    },
  });

  BlockManager.add("text-image-aside-reverse", {
    ...config,
    label: "Image with text aside reverse",
    content: template,
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches(".landing-page-text-aside-reverse__title")) data.enabled = false;
    }
  });
}
